import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-data-item',
    templateUrl: './data-item.component.html',
    styleUrls: ['./data-item.component.scss'],
    standalone: false
})
export class DataItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
